import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { UserState, UserData } from './types';
import { api } from './api';

const initialState: UserState = {};

// Redux Toolkit allows us to write "mutating" logic in reducers. It
// doesn't actually mutate the state because it uses the Immer library,
// which detects changes to a "draft state" and produces a brand new
// immutable state based off those changes
export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logout: () => {
      return initialState;
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
    setActiveExchangeInternalId: (state, action: PayloadAction<string>) => {
      state.activeExchangeInternalId = action.payload;
    },
    setSessionExpiryDate: (state, action: PayloadAction<number>) => {
      state.sessionExpiryDate = new Date(action.payload * 1000);
    },
    setUser: (state, action: PayloadAction<UserData>) => {
      state.user = action.payload;
    },
    setLocale: (state, action: PayloadAction<string>) => {
      state.locale = action.payload;
    },
    setKycTraderInProgress: (state, action: PayloadAction<boolean>) => {
      state.isKycTraderInProgress = action.payload;
    },
    setUserKycInitiatedDate: (state, action: PayloadAction<Date>) => {
      state.userKycInitiatedAt = action.payload;
    },
    setTraderKycInitiatedDate: (state, action: PayloadAction<Date>) => {
      state.traderKycInitiatedAt = action.payload;
    },
    activateExchange: (state, action: PayloadAction<string>) => {
      state.user.exchanges.find(
        (e) => e.internalId === action.payload,
      ).activated = true;
    },
    enable2FA: (state, action: PayloadAction<boolean>) => {
      state.user.ask2FA = action.payload;
      state.user['2FAEnable'] = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.user.matchFulfilled, (state, action) => {
      state.user = action.payload;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  logout,
  setAccessToken,
  setKycTraderInProgress,
  setUser,
  setUserKycInitiatedDate,
  setTraderKycInitiatedDate,
  setSessionExpiryDate,
  setActiveExchangeInternalId,
  activateExchange,
  enable2FA,
  setLocale,
} = userSlice.actions;

export default userSlice.reducer;
